<button
  mat-icon-button
  type="button"
  aria-label="Close"
  (click)="inputs.onCancel()"
>
  <mat-icon>close</mat-icon>
</button>
<fo-contact-form
  [initialValue]="initialValue"
  [companies$]="companies$"
  [companyDisabled]="true"
  (onSave)="onSave($event)"
/>
